import type { RegBenefit } from '@domgen/base-design-system-2.0/atoms/RegBenefits';
import { ShieldIcon } from '@domgen/base-design-system-2.0/icons/ShieldIcon';
import { ClipboardCheck } from '@domgen/base-design-system-2.0/icons/ClipboardCheck';
import { ReceiptIcon } from '@domgen/base-design-system-2.0/icons/ReceiptIcon';

export const registerBenefits: RegBenefit[] = [
  {
    icon: <ShieldIcon />,
    title: 'For your safety',
    subcopy:
      'You are certain to be contacted in the unlikely event a safety notification is required.',
  },
  {
    icon: <ClipboardCheck />,
    title: 'Warranty service',
    subcopy:
      'Obtain a more efficient warranty service in case there is a problem with your product (with a valid model number).',
  },
  {
    icon: <ReceiptIcon />,
    title: 'Confirmation of ownership',
    subcopy:
      'Always have proof of purchase in case of an insurance loss (ex. fire, flood or theft).',
  },
];
